export enum MediaType {
  IMAGE = "Image",
  MP4 = "Mp4",
  COLOR = "Color",
}
